import SvgIcon from '@mui/material/SvgIcon';


const MinusIcon = () => (
    <SvgIcon>
        <path d="M2 6.48438H14.7666" stroke="white" strokeWidth="2.39373" strokeLinecap="round"/>
    </SvgIcon>
);
export default MinusIcon;
